import { selectPromoDetailsById } from '../../selectors/promos';
import { selectTrackingPromoDetailsById } from '../../selectors/tracking';
import { TThunkAction } from '../../types/redux/thunk';
import { trackPromoDetailsClick } from '../../utils/analytics';

/**
 * Redux thunk action, который отправляет аналитику просмотра информации об акции
 */
export const trackPromoDetailsClickAction = (id: string): TThunkAction<void> => {
  return (dispatch, getState) => {
    const state = getState();
    const params = selectTrackingPromoDetailsById(id)(state);
    const details = selectPromoDetailsById(id)(state);

    trackPromoDetailsClick(params, details.isBankMortgage);
  };
};
